export default __webpack_public_path__ + "static/media/system_05_01.1d83147a.jpg";